export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/login.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('@/views/register/register.vue'),
  },
  {
    path: '/forget-password',
    name: 'forgetPassword',
    component: () => import('@/views/forgetPassword/forgetPassword.vue'),
  },
  {
    path: '/wx-mini-program',
    name: 'wxMiniProgram',
    component: () => import('@/views/wxMiniProgram/wxMiniProgram.vue'),
  },
  // {
  //   path: '/404',
  //   name: 'exception404',
  //   component: () => import('@/views/exception/exception404.vue'),
  // },
];
